import { Action } from '../actions';
import { mergeMultipleObjects } from '../helpers';
import { transformProject } from '../project/project.transformers';

export function threadProjectsReducer(state = {}, action: Action) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'threads') {
        const contextDetails = action.payload.result.context_details;
        if (!contextDetails || !contextDetails.projects) {
          return state;
        }

        return mergeMultipleObjects<'threadProjects'>(
          state,
          Object.values(contextDetails.projects).map(transformProject),
        );
      } else if (action.payload.type === 'threadProjects') {
        const { result } = action.payload;
        if (result.projects) {
          return mergeMultipleObjects<'threadProjects'>(
            state,
            Object.values(result.projects).map(transformProject),
          );
        }
        return state;
      }
      return state;
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/zh/webapp/src/app/@shared/datastore/thread/threadProject.reducer.ts